// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"686":"4ec6814d","858":"9f195924"}[chunkId] + ".chunk.js";
};